var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _vm.categories.length
        ? _c(
            "v-list",
            _vm._l(_vm.categories, function (category, categoryIndex) {
              return _c(
                "v-list-group",
                {
                  key: category.name,
                  attrs: { "prepend-icon": "mdi-file-tree", "no-action": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function () {
                          return [
                            _c(
                              "v-row",
                              {
                                attrs: {
                                  justify: "space-between",
                                  align: "center",
                                  "no-gutters": "",
                                },
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "10" } },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(category.name)),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.addCategoryChild(
                                                  category.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v(" mdi-plus ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.editCategory(
                                                  category
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-pencil-outline"),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.removeCategory(
                                                  category.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "red" } },
                                              [_vm._v("mdi-trash-can-outline")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            link: "",
                            small: "",
                            outlined: "",
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addCategoryChild(category.id)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v(" mdi-plus ")]
                          ),
                          _vm._v(" Создать подкатегорию "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(category.children || [], function (child) {
                    return _c(
                      "v-list-item",
                      {
                        key: child.name,
                        attrs: { "prepend-icon": "mdi-file-tree" },
                        on: {
                          click: function ($event) {
                            return _vm.editCategory(child)
                          },
                        },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            attrs: {
                              justify: "space-between",
                              align: "center",
                              "no-gutters": "",
                            },
                          },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "11" } },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(child.name)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      justify: "start",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.editCategory(child)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-pencil-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.removeCategory(child.id)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "red" } },
                                          [_vm._v("mdi-trash-can-outline")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  categoryIndex < _vm.categories.length - 1
                    ? _c("v-divider")
                    : _vm._e(),
                ],
                2
              )
            }),
            1
          )
        : _c("v-subheader", [_vm._v(" Список пуст ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }